import { render, staticRenderFns } from "./AimsAndObjectives.vue?vue&type=template&id=c47f8f9c&scoped=true&"
import script from "./AimsAndObjectives.vue?vue&type=script&lang=js&"
export * from "./AimsAndObjectives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47f8f9c",
  null
  
)

export default component.exports